// import { methodNameEnum } from '../../../recoil/selectors/makePHPRequest';
import { Formik } from 'formik';
import { ModalWithStyles } from './ModalWithStyles';
// import { endpointEnum } from '../../../services/rest/makeAPIRequest';

export function DeleteCadenceModal({
  deleteId,
  handleClose,
  show,
  handleDeletion,
}) {
  return (
    <Formik
      onSubmit={async (values, actions) => {
        handleDeletion(values.deleteId);
        actions.resetForm({});
        handleClose();
      }}
      enableReinitialize={true}
      initialValues={{
        deleteId: deleteId ?? '',
      }}
    >
      {(formik) => (
        <>
          <form
            className="form form-label-right"
            onSubmit={formik.handleSubmit}
            noValidate
          >
            <ModalWithStyles
              onSubmit={() => {
                formik.handleSubmit();
              }}
              title="Delete Cadence"
              aria-labelledby="example-modal-sizes-title-md"
              show={show}
              onHide={handleClose}
              isSubmitting={formik.isSubmitting}
              isLoading={formik.isSubmitting}
              deleteDialog={true}
              size="xs"
            >
              <p>
                Deleting this cadence will stop any further actions from this
                cadence to be executed. This action cannot be reversed.
              </p>
              <p>Are you sure you want to Delete this Cadence?</p>
            </ModalWithStyles>
          </form>
        </>
      )}
    </Formik>
  );
}
